if (__DEV__) {
  // require('./modules');
  require('./components/ApplicationWizardContainer');
  require('./pages/application-details/components/ApplicationDetailsPage');
  require('./pages/application-details/components/CreateApplicationContextMenusPage');
}

const indexPath = '/applications/overview/new/details';
export default store => ({
  path: 'new',

  onEnter(nextState, replace) {
    // do not allow direct navigation to any pages but details (the first page
    // in the wizard)
    if (!nextState.location.pathname.match(/details\/?$/)) {
      replace(indexPath);
    }
  },

  getComponent(nextState, cb) {
    import(/* webpackChunkName: "application-wizard" */
    './components/ApplicationWizardContainer')
      .then(loadRoute(cb))
      .catch(errorLoading);
  },

  childRoutes: [
    {
      path: 'details',
      getComponent(nextState, cb) {
        import(/* webpackChunkName: "application-wizard" */
        './pages/application-details/components/ApplicationDetailsPage')
          .then(loadRoute(cb))
          .catch(errorLoading);
      }
    }
  ]
});

function errorLoading(err) {
  console.error('Dynamic page loading failed', err);
}

function loadRoute(cb) {
  return module => cb(null, module.default);
}



// WEBPACK FOOTER //
// ./src/client/plugins/applications/pages/application-wizard/index.js